'use client';

import React from 'react';

import Icon from 'molecules/Icon';
import Link from 'molecules/Link';

import styles from 'components/ListingDeck/LearningCard/learningCard.module.scss';

import { convertIdToModelName } from 'utils/builder/builderTemplates';
import { replaceFirstPathSegment } from 'utils/functions';

import type { IconIds } from 'molecules/Icon';
import type { FC } from 'react';

interface LearningCardProps {
  title?: string;
  modelId: string;
  link: string;
}

const LearningCard: FC<LearningCardProps> = ({ modelId, title, link }) => {
  const convertedModelName = convertIdToModelName(modelId);
  const lowerCasedModel = `${convertedModelName?.toLowerCase().replace(/\s+/g, '')}-card`;
  const updatedUrl = replaceFirstPathSegment(link, 'healthcare-insights') ?? '';

  return (
    <div className={styles.learningCard}>
      <Link href={updatedUrl} className={styles.link}>
        <article>
          <div className={styles.learningCard__header}>
            <p className={styles.learningCard__product}></p>
          </div>
          <div className={styles.learningCard__content}>
            <div className={styles.learningCard__typeContainer}>
              {lowerCasedModel && (
                <Icon className={styles.learningCard__icon} icon={lowerCasedModel as IconIds} size={74} />
              )}
            </div>
            {title && <h2 className={styles.learningCard__title}>{title}</h2>}
          </div>
        </article>
      </Link>
    </div>
  );
};

export default LearningCard;
